const routes = [

	
	//---- "System Admin" / "Lotus Admin" pages
	{ 
		path: '/system-admin/access-definitions', 
		component: () => import("./system-admin/access-definitions.vue"),
		meta: { layout: "primary", section: "system-admin", pageTitle: "Lotus Admin > Feature Access Definitions" }
	},

	{ 
		path: '/system-admin/timesheet-generation', 
		component: () => import("./system-admin/timesheet-generation.vue"),
		meta: { layout: "primary", section: "system-admin", pageTitle: "Lotus Admin > Timesheet Generation" }
	},

	{ 
		path: '/system-admin/accounts', 
		name: "system-admin-accounts",
		component: () => import("./system-admin/accounts.vue"),
		meta: { layout: "primary", section: "system-admin", pageTitle: "Lotus Admin > Accounts" }
	},
	{ 
		path: '/system-admin/accounts/new', 
		name: "ystem-admin-accounts-edit",
		component: () => import("./system-admin/account.vue"),
		meta: { layout: "primary", section: "system-admin", pageTitle: "Lotus Admin > Account" }
	},


	{ 
		path: '/system-admin/account/:id/edit', 
		name: "system-admin-accounts-edit",
		component: () => import("./system-admin/account.vue"),
		meta: { layout: "primary", section: "system-admin", pageTitle: "Lotus Admin > Account > Edit" }
	},



	{ 
		path: '/system-admin/review-timesheets', 	//NOTE: This is the primary version for the following 4, which should really be considered obsolete and consolidated into this one (via filters)
		component: () => import("./system-admin/timesheets/list-timesheets.vue"),
		name: "SystemAdminReviewTimesheets",
		meta: { layout: "primary", pageTitle: "System Admin > Review Timesheets" }
	},
	{
		path: '/system-admin/timesheets/id/:id/activity', 
		component: () => import("./system-admin/timesheets/timesheet-activity.vue"),
		name: "SystemAdminTimesheetsTimesheetActivity", 
		meta: { layout: "primary", pageTitle: "System Admin > Timesheet Activity" }
	},


]


export default routes;